import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { jwtTenantId } from '../utils/jwt.util';

/**
 * Bir nechta biznes bo'lsa, JWT da TenantId bo'lmaguncha asosiy ilovaga kiritmaydi.
 */
export const businessTenantGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const role = auth.user()?.role;

  if (role === 'SuperAdmin' || role === 'Admin' || role === 'Operator') {
    return true;
  }

  const token = auth.getAccessToken();
  if (jwtTenantId(token)) {
    return true;
  }

  if (auth.pendingBusinessCount() > 1) {
    router.navigate(['/select-business'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  return true;
};
